import { render, staticRenderFns } from "./AppList.vue?vue&type=template&id=1ae85a0b&scoped=true&"
import script from "./AppList.vue?vue&type=script&lang=js&"
export * from "./AppList.vue?vue&type=script&lang=js&"
import style0 from "./AppList.vue?vue&type=style&index=0&id=1ae85a0b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae85a0b",
  null
  
)

export default component.exports